import { useContext } from 'react';
import { ConfirmationContext, type ConfirmationContextValue } from '../contexts/ConfirmationContext';

export function useConfirmation(): ConfirmationContextValue {
  const ctx = useContext(ConfirmationContext);
  if (!ctx) {
    throw new Error('useConfirmation deve ser usado dentro de <ConfirmationProvider>');
  }
  return ctx;
}
